<template>
  <div class="cate-step-card">
    <span class="line"></span>
    <span class="title_text">{{ title }}</span>
    <span class="detail_text">{{ detail }}</span>
  </div>
</template>

  <script>
export default {
  name: "cate-step-card",
  props: {
    title: {
      tyep: String,
      default() {
        return "";
      },
    },
    detail: {
      tyep: String,
      default() {
        return "";
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.cate-step-card {
  background-color: #ffffff;
  height: 44px;
  display: flex;
  flex-direction: row;
  align-items: center;
  .line {
    display: inline-block;
    width: vw(8);
    height: vw(36);
    border-radius: vw(4);
    background-color: #ff3030;
  }
  .title_text {
    margin-left: vw(10);
    color: #333333;
    font-size: vw(36);
    flex: 1;
    font-family: "PingFang-SC-Medium";
    font-weight: 600;
  }
  .detail_text {
    color: #999;
    font-size: vw(24);
    max-width: 70%;
    font-family: "PingFangSC-Regular";
    overflow: hidden;
  }
}
</style>
